import Reveal from "@/components/Reveal";

const outcomes = [
  {
    kicker: "Live assistance",
    title: "Useful guidance while the buyer is still on the line",
    copy: "Answers, objection support and the next best action arrive inside the live conversation.",
  },
  {
    kicker: "Conversation intelligence",
    title: "Evidence from every call, not a small sample",
    copy: "Managers see buyer intent, call quality, missed opportunities and coaching priorities.",
  },
  {
    kicker: "Follow-through",
    title: "Important commitments leave the call as clear actions",
    copy: "Summaries, reminders and tasks reduce the manual work that causes momentum to disappear.",
  },
];

export default function Outcomes() {
  return (
    <section className="outcomes" id="leaders" data-testid="outcomes-section">
      <div className="wrap">
        <div className="label mono">What ThinkWire delivers</div>
        <h2 className="section-title">
          Reps sell. ThinkWire remembers, guides and follows through.
        </h2>
        <Reveal className="outcome-grid">
          {outcomes.map((o) => (
            <article className="outcome" key={o.kicker}>
              <small>{o.kicker}</small>
              <h3>{o.title}</h3>
              <p>{o.copy}</p>
            </article>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
